<atom-form-input *ngIf="initialized"
  [required]="required"
  [editable]="editable"
  [group]="group"
  [controlName]="controlName"
  [fieldName]="fieldName"
  [fieldCounter]="options.fieldCounter ? options.fieldCounter : false"
  [maxLen]="options.maxLen ? options.maxLen : 0">

  <form [formGroup]="group" class="flex w-full flex-column">
    <input *ngIf="textFormType === InputType.text && editable"
           [id]="controlName+'Input'"
           class="configuration-input-field w-full"
           [placeholder]="options.placeholder ? options.placeholder : ''"
           [formControlName]="controlName"
           [type]="inputType"
           (input)="inputChanged.emit($event)"
           pInputText/>
    <p-inputNumber *ngIf="textFormType != InputType.text  && textFormType != InputType.password && editable"
                   [id]="controlName+'Input'"
                   class="input-number-config-input-field"
                   [min]="_min"
                   [max]="_max"
                   [formControlName]="controlName"
                   [suffix]="options.suffix"
                   [minFractionDigits]="_minFractionDigits"
                   [maxFractionDigits]="_maxFractionDigits"
                   (onInput)="inputChanged.emit($event)"
                   [mode]="inputMode"
                   locale="en-US"/>
    <p-password *ngIf="textFormType === InputType.password && editable"
                [id]="controlName+'Input'"
                class="configuration-input-field-password w-full"
                [feedback]="false"
                [formControlName]="controlName"
                (input)="inputChanged.emit($event)"
                pPassword/>
    <span *ngIf="options.description" class="text-xs secondary-text-color">{{options.description}}</span>
    <span *ngIf="!editable" class="configuration-input-label-field w-full">
      {{ _nonEditLabelOverride ? _nonEditLabelOverride : group.controls[controlName].value }}{{ _suffix && !_nonEditLabelOverride ? _suffix : ''}}
    </span>
  </form>
</atom-form-input>
